/**
 * LogoutBodyContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled logout body container.
 */
const LogoutBodyContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: ${220 * Screen.widthRatio}px;
  width: ${800 * Screen.widthRatio}px;
`;

export default LogoutBodyContainer;
